(() => {
  const badgeSelector = '.shopify-app-block .jdgm-preview-badge[data-widget-name="preview_badge"] .jdgm-prev-badge';

  const showSummaries = () => {
    const badges = document.querySelectorAll(badgeSelector);
    let ready = false;
    for (const badge of badges) {
      const stars = badge.querySelector('.jdgm-prev-badge__stars');
      if (!stars) continue;
      ready = true;

      const count = Number.parseInt(badge.dataset.numberOfReviews || '', 10);
      const rating = Number.parseFloat(badge.dataset.averageRating || '');
      let summary = badge.querySelector('.vhalam-product-rating-summary');

      if (!Number.isFinite(count) || count < 1 || !Number.isFinite(rating) || rating <= 0) {
        summary?.remove();
        continue;
      }

      const score = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1
      }).format(rating);
      const reviewText = badge.querySelector('.jdgm-prev-badge__text')?.textContent?.trim() || String(count);
      const label = `${score} (${reviewText})`;

      if (!summary) {
        summary = document.createElement('span');
        summary.className = 'vhalam-product-rating-summary';
        stars.insertAdjacentElement('afterend', summary);
      }
      if (summary.textContent !== label) summary.textContent = label;
    }
    return ready;
  };

  const start = () => {
    if (showSummaries()) return;

    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (showSummaries() || attempts >= 100) window.clearInterval(timer);
    }, 200);
  };

  start();
  document.addEventListener('shopify:section:load', start);
})();
